import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/invoices/')({
  component: InvoicesPage,
})

function InvoicesPage(): JSX.Element {
  return <div>Facturas — placeholder</div>
}
